import React, { useState } from "react";
import { FaSortAlphaDown, FaSortNumericDown, FaTimesCircle, FaCheckCircle } from "react-icons/fa";


const FilterModel = ({ isOpen, onClose, onApply }) => {
    const [localFilters, setLocalFilters] = useState({
        per_page: 10,
        page: 1,
        order_by: "created_at",
        // status: "all",
      });
      
      const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
      
      const applyFilters = () => {
        onApply(localFilters);
      };
      
      return (
        <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 ${isOpen ? "flex" : "hidden"} justify-center items-center`}>
        <div className="bg-white p-6 rounded-2xl shadow-2xl w-96 relative">
          <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
            <FaSortAlphaDown className="text-blue-500" />
            Filter Outlet
          </h2>
      
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2 mb-1">
                <FaSortNumericDown className="text-gray-400" />
                Per Page
              </label>
              <input
                type="number"
                name="per_page"
                value={localFilters.per_page}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
      
            <div>
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2 mb-1">
                <FaSortNumericDown className="text-gray-400" />
                Page
              </label>
              <input
                type="number"
                name="page"
                value={localFilters.page}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
      
            <div>
              <label className="text-sm font-medium text-gray-700 flex items-center gap-2 mb-1">
                <FaSortAlphaDown className="text-gray-400" />
                Order By
              </label>
              <select
                name="order_by"
                value={localFilters.order_by}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg bg-white focus:ring-2 focus:ring-blue-400 focus:outline-none"
              >
                <option value="created_at">Created At</option>
                <option value="name">Name</option>
              </select>
            </div>
          </div>
      
          <div className="mt-6 space-y-3">
            <button
              onClick={applyFilters}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg flex items-center justify-center gap-2 transition"
            >
              <FaCheckCircle />
              Apply Filters
            </button>
      
            <button
              onClick={onClose}
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 rounded-lg flex items-center justify-center gap-2 transition"
            >
              <FaTimesCircle />
              Close
            </button>
          </div>
        </div>
      </div>
      
  );
};

export default FilterModel;
